module.exports = __webpack_public_path__ + "img/icon_more_white.c4bdf9ca.svg";